import Popover from 'material-ui/Popover';

/**
 * Our version of MaterialUi/Popver doesn't close when the escape key is pressed.  This adds the keypress event handler.
 */
export default class EvPopover extends Popover {
  constructor(props) {
    super(props);

    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    document.addEventListener('keydown', this.handleKeyPress, true);
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    document.removeEventListener('keydown', this.handleKeyPress, true);
  }

  /**
   * Event handler for keypress.  Fires parent event if the key == Escape
   */
  handleKeyPress(event) {
    event = event || window.event;
    let isEscape = false;
    if ('key' in event) {
      isEscape = event.key === 'Escape' || event.key === 'Esc';
    } else {
      isEscape = event.keyCode === 27;
    }
    if (isEscape) {
      this.requestClose('escape');
    }
  }
}
